import { create } from 'zustand';
import {  MenuData, VisualContent } from '../interfaces/domain/menu';


interface Feature {
  name: string;
  priority: number;
  items: string[];
}

interface ItemsState {
  menuData: MenuData;
  featuresData: Feature[];
  carouselContent: VisualContent[];
  hasFilter: boolean;

  // Acciones
  setMenu: (menuData: MenuData) => void;
  setHasFilter: (value: boolean) => void;
  setFeatures: (features: Feature[]) => void;
  setCarouselContent: (data: VisualContent[]) => void;
}

export const useItemsStore = create<ItemsState>((set) => ({
  menuData: {
    categories: [],
  },
  hasFilter: false,
  featuresData: [],
  carouselContent: [],

  setMenu: (menuData) =>

    set({

      menuData
    }),
  setHasFilter: (value) => set({ hasFilter: value }),
  setFeatures: (features) => set({ featuresData: features }),
  setCarouselContent: (carouselContent) => set({ carouselContent }),
}));